__turbopack_context__.v({
  "actions": "OfferRequired-module__4LN7rq__actions",
  "badge": "OfferRequired-module__4LN7rq__badge",
  "card": "OfferRequired-module__4LN7rq__card",
  "content": "OfferRequired-module__4LN7rq__content",
  "description": "OfferRequired-module__4LN7rq__description",
  "header": "OfferRequired-module__4LN7rq__header",
  "iconContainer": "OfferRequired-module__4LN7rq__iconContainer",
  "title": "OfferRequired-module__4LN7rq__title",
});
